<h1 mat-dialog-title>Deal Jacket Created</h1>
<div mat-dialog-content class="deal-create-modal">
    <p data-test="sdj-complete-buyer-name">
        The Deal Jacket for <b>{{deal.buyer?.firstName}} {{deal.buyer?.middleName}} {{deal.buyer?.lastName}}</b> has been created, 
        {{ message }}
    </p>
    <ng-container *ngIf="deal?.createError">
        <h3 class="error-header">Error:</h3>
        <p class="error-details" [innerHTML]="deal?.createError?.message">
        </p>
    </ng-container>
</div>
<div class="form-footer">
    <button mat-button class="primary" (click)="close()">Continue</button>
</div>
